import { createSelector } from 'reselect'

const creditCardNumberSelector = ({ creditCardNumber }) => creditCardNumber
const interestRateSelector = ({ interestRate }) => interestRate
const installmentsOptionsSelector = ({ installmentsOptions }) =>
	installmentsOptions
const installmentsQttSelector = ({ installmentsQtt }) => installmentsQtt

const getCardLastFourNumbers = createSelector(
	[creditCardNumberSelector],
	(creditCardNumber) => `**** **** **** ${creditCardNumber.slice(-4)}`
)

const getInterestRate = createSelector(
	[interestRateSelector],
	(interestRate) => interestRate
)

const getInstallmentsOptions = createSelector(
	[installmentsOptionsSelector],
	(installmentsOptions) => installmentsOptions
)

const getInstallmentsQtt = createSelector(
	[installmentsQttSelector],
	(installmentsQtt) => installmentsQtt
)

const Selectors = {
	getCardLastFourNumbers,
	getInterestRate,
	getInstallmentsOptions,
	getInstallmentsQtt,
}

export default Selectors
